import { render, staticRenderFns } from "./BuscadorBeta.vue?vue&type=template&id=00f530dc&"
import script from "./BuscadorBeta.vue?vue&type=script&lang=js&"
export * from "./BuscadorBeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports